import React from 'react';

const CheckboxOrRadioGroupContext = /*#__PURE__*/React.createContext({});

export { CheckboxOrRadioGroupContext as default };
